import styled from 'styled-components';

export const Overlay = styled.div`
  background: rgba(255, 255, 255, 0.7);
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
`;

/* z-index para ficar por cima da grade cinética, que preenche o véu inteiro
   de forma absoluta. */
export const Spinner = styled.img`
  position: relative;
  z-index: 1;
  width: 300px;

  @media (max-width: 600px) {
    width: 220px;
  }
`;
